import LoginDataActions from "@redux/feature/Login/action/LoginDataActions";
export default (function () {
    return {
        login: new LoginDataActions(),
    };
});
